var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 114,
    viewBox: "0 0 82 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.8951 57.178V35.1953C71.8951 18.1368 58.0648 4.30655 40.9937 4.30655C23.9226 4.30655 10.0923 18.1368 10.0923 35.1953V56.8765C7.15292 58.8236 5.28125 61.7127 5.28125 64.9411C5.28125 70.8073 11.4364 75.5681 19.0361 75.5681C26.6359 75.5681 32.791 70.8073 32.791 64.9411C32.791 64.514 32.7533 64.0994 32.6905 63.6849H48.8446C48.7818 64.0994 48.7441 64.514 48.7441 64.9411C48.7441 70.8073 54.8993 75.5681 62.499 75.5681C70.0987 75.5681 76.2539 70.8073 76.2539 64.9411C76.2539 61.876 74.5581 59.1125 71.8699 57.178H71.8951Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.5242 76.8744C54.2461 76.8744 47.5006 71.5483 47.4629 64.9911H34.1226C34.0849 71.5483 27.3393 76.8744 19.0613 76.8744C10.7832 76.8744 4 71.5232 4 64.9409C4 61.6121 5.74605 58.4592 8.81107 56.1981V35.1952C8.81107 17.4458 23.2568 3 41.0063 3C58.7557 3 73.2015 17.4458 73.2015 35.1952V56.5247C75.9901 58.7481 77.5854 61.788 77.5854 64.9283C77.5854 71.5106 70.8273 76.8618 62.5242 76.8618V76.8744ZM32.7157 62.3909H48.8698C49.2466 62.3909 49.6109 62.5542 49.8622 62.8431C50.1134 63.132 50.2139 63.5089 50.1636 63.8857C50.1008 64.2751 50.0757 64.6269 50.0757 64.9409C50.0757 70.0786 55.6656 74.2741 62.5367 74.2741C69.4079 74.2741 74.9978 70.0911 74.9978 64.9409C74.9978 62.4035 73.6286 60.0168 71.1539 58.233C70.8148 57.9944 70.6138 57.5924 70.6138 57.1779V35.1952C70.6138 18.8778 57.3363 5.60024 41.0188 5.60024C24.7014 5.60024 11.4239 18.8778 11.4239 35.1952V56.8764C11.4239 57.3161 11.2103 57.718 10.846 57.9567C8.15787 59.7404 6.62536 62.2779 6.62536 64.9283C6.62536 70.066 12.2152 74.2616 19.0864 74.2616C25.9576 74.2616 31.5474 70.0786 31.5474 64.9283C31.5474 64.6143 31.5223 64.2751 31.4595 63.8732C31.3967 63.4963 31.5098 63.1195 31.761 62.8306C32.0122 62.5417 32.3639 62.3784 32.7533 62.3784L32.7157 62.3909Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.5183 91.898C71.5183 81.7985 63.3282 73.6084 53.2287 73.6084H27.867C17.7675 73.6084 9.57739 81.7985 9.57739 91.898V111.996H71.5183V91.898Z",
    fill: "#FFCF02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.5183 113.29H9.5774C8.86139 113.29 8.271 112.712 8.271 111.984V91.8854C8.271 81.0825 17.0641 72.302 27.867 72.302H53.2287C64.0316 72.302 72.8247 81.0825 72.8247 91.8854V111.984C72.8247 112.7 72.2469 113.29 71.5183 113.29ZM10.8712 110.69H70.2119V91.898C70.2119 82.5396 62.5871 74.9148 53.2161 74.9148H27.8544C18.4835 74.9148 10.8587 82.5271 10.8587 91.898V110.69H10.8712Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.9904 70.4305V74.8647C47.9904 78.0679 44.7369 80.6681 40.7298 80.6681C36.7101 80.6681 33.4692 78.0805 33.4692 74.8647V70.2044",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.7298 81.9618C36.0067 81.9618 32.1628 78.7712 32.1628 74.8646V70.2042C32.1628 69.4882 32.7407 68.8978 33.4692 68.8978C34.1978 68.8978 34.7756 69.4757 34.7756 70.2042V74.8646C34.7756 77.3517 37.4512 79.3616 40.7424 79.3616C44.0335 79.3616 46.7091 77.3392 46.7091 74.8646V70.4303C46.7091 69.7143 47.2869 69.1239 48.0155 69.1239C48.7441 69.1239 49.3219 69.7018 49.3219 70.4303V74.8646C49.3219 78.7838 45.4781 81.9618 40.7549 81.9618H40.7298Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M48.719 35.4086C37.2252 33.0094 32.4016 26.8542 30.3792 22.106C29.01 26.4648 25.6309 33.2229 17.7171 35.0192C17.7171 35.1574 17.7046 35.283 17.7046 35.4086V47.5808C17.7046 60.494 28.1683 70.9452 41.0816 70.9452C53.9948 70.9452 64.4586 60.4815 64.4586 47.5808V35.4086H48.7316H48.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.0692 72.2517C27.465 72.2517 16.3857 61.185 16.3857 47.5808V35.4087C16.3857 35.3082 16.3857 35.2203 16.3857 35.1324V34.9942C16.3983 34.3912 16.8254 33.8888 17.4032 33.7506C24.4628 32.1553 27.666 26.3267 29.1106 21.7167C29.2739 21.2016 29.7386 20.8373 30.2914 20.8122C30.8441 20.7871 31.334 21.1011 31.5475 21.6036C33.4443 26.0504 37.979 31.8161 48.8322 34.1149H64.421C65.137 34.1149 65.7274 34.6927 65.7274 35.4213V47.5934C65.7274 61.1975 54.6607 72.2642 41.044 72.2642L41.0692 72.2517ZM18.9985 36.0242V47.5808C18.9985 59.753 28.897 69.6515 41.0692 69.6515C53.2413 69.6515 63.1398 59.753 63.1398 47.5808V36.7151H48.7066C48.6186 36.7151 48.5307 36.7151 48.4428 36.69C38.4564 34.6048 33.2559 29.7686 30.5426 25.3093C28.7589 29.3164 25.3421 34.2028 18.986 36.0368L18.9985 36.0242Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M55.0374 45.1313C55.0374 46.2744 54.1078 47.204 52.9647 47.204C51.8216 47.204 50.8921 46.2744 50.8921 45.1313C50.8921 43.9882 51.8216 43.0587 52.9647 43.0587C54.1078 43.0587 55.0374 43.9882 55.0374 45.1313Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M32.3135 45.1313C32.3135 46.2744 31.384 47.204 30.2409 47.204C29.0978 47.204 28.1682 46.2744 28.1682 45.1313C28.1682 43.9882 29.0978 43.0587 30.2409 43.0587C31.384 43.0587 32.3135 43.9882 32.3135 45.1313Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M41.9412 61.4558C44.7801 61.4558 47.2924 60.0614 48.2094 57.9888C48.4229 57.4989 48.2094 56.921 47.7069 56.7075C47.217 56.494 46.6392 56.7075 46.4256 57.21C45.8352 58.5666 43.9887 59.5087 41.9537 59.5087C39.9188 59.5087 38.135 58.5917 37.5069 57.2853C37.2683 56.7954 36.6904 56.5944 36.2005 56.8331C35.7106 57.0718 35.5097 57.6496 35.7483 58.1395C36.703 60.1368 39.2028 61.4683 41.9537 61.4683L41.9412 61.4558Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M43.908 53.2838H41.0189C40.4787 53.2838 40.0391 52.8441 40.0391 52.304V45.0685C40.0391 44.5284 40.4787 44.0887 41.0189 44.0887C41.559 44.0887 41.9987 44.5284 41.9987 45.0685V51.3242H43.9206C44.4607 51.3242 44.9004 51.7638 44.9004 52.304C44.9004 52.8441 44.4607 53.2838 43.9206 53.2838H43.908Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M49.5604 70.5307L41.0437 79.7886L47.6008 88.4686L55.5774 74.3871L49.5604 70.5307Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M47.6009 89.7625C47.1989 89.7625 46.8095 89.5741 46.5583 89.2475L39.9886 80.5675C39.6118 80.065 39.6369 79.3616 40.064 78.8968L48.5807 69.6389C49.0078 69.1742 49.7112 69.0862 50.2388 69.4254L56.2683 73.2818C56.8462 73.6586 57.0346 74.4123 56.6954 75.0153L48.7189 89.0967C48.5053 89.4736 48.1033 89.7248 47.6763 89.7499C47.6511 89.7499 47.6135 89.7499 47.5883 89.7499L47.6009 89.7625ZM42.7396 79.864L47.4501 86.0945L53.844 74.8143L49.774 72.214L42.727 79.864H42.7396Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M31.9997 70.5308L40.5165 79.7886L33.9468 88.4686L25.9702 74.3872L31.9997 70.5308Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M33.9467 89.7624C33.9467 89.7624 33.8839 89.7624 33.8588 89.7624C33.4191 89.7373 33.0297 89.4861 32.8161 89.1093L24.8396 75.0278C24.5004 74.4248 24.6888 73.6586 25.2667 73.2943L31.2962 69.4379C31.8238 69.0987 32.5272 69.1867 32.9543 69.6514L41.4585 78.9093C41.8856 79.3741 41.9233 80.0775 41.5338 80.58L34.9767 89.26C34.7255 89.5866 34.3487 89.775 33.9341 89.775L33.9467 89.7624ZM27.7162 74.8142L34.11 86.0945L38.8206 79.864L31.7861 72.214L27.7162 74.8142Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M43.4309 91.2195C43.4309 92.5008 42.3883 93.5308 41.1195 93.5308C39.8508 93.5308 38.7957 92.4882 38.7957 91.2195C38.7957 89.9508 39.8383 88.9082 41.1195 88.9082C42.4008 88.9082 43.4309 89.9508 43.4309 91.2195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M41.1195 94.5107C39.2981 94.5107 37.8284 93.041 37.8284 91.2196C37.8284 89.3982 39.3106 87.9285 41.1195 87.9285C42.9284 87.9285 44.4106 89.4108 44.4106 91.2196C44.4106 93.0285 42.9284 94.5107 41.1195 94.5107ZM41.1195 89.8881C40.3784 89.8881 39.7754 90.4911 39.7754 91.2322C39.7754 91.9733 40.3784 92.5637 41.1195 92.5637C41.8606 92.5637 42.4636 91.9608 42.4636 91.2322C42.4636 90.5036 41.8606 89.8881 41.1195 89.8881Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M43.4309 103.756C43.4309 105.037 42.3883 106.067 41.1195 106.067C39.8508 106.067 38.7957 105.037 38.7957 103.756C38.7957 102.475 39.8383 101.445 41.1195 101.445C42.4008 101.445 43.4309 102.475 43.4309 103.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M41.1195 107.047C39.2981 107.047 37.8284 105.577 37.8284 103.756C37.8284 101.935 39.3106 100.465 41.1195 100.465C42.9284 100.465 44.4106 101.935 44.4106 103.756C44.4106 105.577 42.9284 107.047 41.1195 107.047ZM41.1195 102.425C40.3784 102.425 39.7754 103.027 39.7754 103.769C39.7754 104.51 40.3784 105.1 41.1195 105.1C41.8606 105.1 42.4636 104.497 42.4636 103.769C42.4636 103.04 41.8606 102.425 41.1195 102.425Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M9.9895 49.0724V28.8166C9.9895 14.0843 23.7227 2.13187 40.6696 2.13187C57.6165 2.13187 71.3587 14.0843 71.3587 28.8257V49.0815C71.3587 63.8229 57.6256 75.7753 40.6696 75.7753",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M47.1062 75.6848C47.1062 77.9938 45.2322 79.8681 42.9237 79.8681H37.1299C34.8214 79.8681 32.9475 77.9938 32.9475 75.6848C32.9475 73.3758 34.8214 71.5014 37.1299 71.5014H42.9237C45.2322 71.5014 47.1062 73.3758 47.1062 75.6848Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M11.7095 33.67C6.42264 33.67 2.13159 37.9621 2.13159 43.2501C2.13159 48.5382 6.42264 52.8302 11.7095 52.8302C12.479 52.8302 13.2213 52.7306 13.9365 52.5586V33.9417C13.2213 33.7696 12.479 33.67 11.7095 33.67Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M70.2905 33.67C75.5774 33.67 79.8684 37.9621 79.8684 43.2501C79.8684 48.5382 75.5774 52.8302 70.2905 52.8302C69.521 52.8302 68.7787 52.7306 68.0544 52.5586V33.9417C68.7696 33.7696 69.512 33.67 70.2905 33.67Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M16.5709 51.97C16.5709 53.1924 15.5751 54.1884 14.353 54.1884C13.1308 54.1884 12.135 53.1924 12.135 51.97V34.3944C12.135 33.172 13.1308 32.176 14.353 32.176C15.5751 32.176 16.5709 33.172 16.5709 34.3944V51.97Z",
    fill: "#FFE848",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M69.8651 51.97C69.8651 53.1924 68.8693 54.1884 67.6472 54.1884C66.425 54.1884 65.4292 53.1924 65.4292 51.97V34.3944C65.4292 33.172 66.425 32.176 67.6472 32.176C68.8693 32.176 69.8651 33.172 69.8651 34.3944V51.97Z",
    fill: "#FFE848",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultant);
export default __webpack_public_path__ + "static/media/consultant.f489da1168a8957a07c74e02812020cc.svg";
export { ForwardRef as ReactComponent };